var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doRender)?_c('div',{staticClass:"view view_Nachrichten"},[_c('h1',[_vm._v("This is a Nachrichten page")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }